import { LogIn, UserPlus, X, ShieldAlert } from "lucide-react";
import { LocalizedLink } from "@/i18n/LocalizedLink";
import { useLang } from "@/i18n/LangContext";

export default function LoginRequiredModal({ open, onClose, next = "/" }) {
  const { t } = useLang();
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in"
      onClick={onClose}
      data-testid="login-required-modal"
    >
      <div
        className="bg-[#0c0c0c] border border-white/10 rounded-2xl max-w-md w-full p-8 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 end-4 text-zinc-500 hover:text-white"
          data-testid="login-required-close"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-brand/10 border border-brand/30 mb-5">
          <ShieldAlert className="w-6 h-6 text-brand-cyan" />
        </div>

        <h3 className="font-heading text-2xl font-bold mb-2">
          {t("auth.login_required_title")}
        </h3>
        <p className="text-zinc-400 mb-7 text-sm leading-relaxed">
          {t("verify.login_required")}
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <LocalizedLink
            to={`/signin?next=${encodeURIComponent(next)}`}
            className="flex-1 inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-hover text-white font-semibold px-5 py-3 rounded-lg glow-blue transition-all"
            data-testid="login-required-signin"
          >
            <LogIn className="w-4 h-4" /> {t("nav.sign_in")}
          </LocalizedLink>
          <LocalizedLink
            to={`/signup?next=${encodeURIComponent(next)}`}
            className="flex-1 inline-flex items-center justify-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-semibold px-5 py-3 rounded-lg transition-all"
            data-testid="login-required-signup"
          >
            <UserPlus className="w-4 h-4" /> {t("nav.sign_up")}
          </LocalizedLink>
        </div>
      </div>
    </div>
  );
}
